import { render } from "./VideoPlayerControlsBadge.vue?vue&type=template&id=11dcaf08"
import script from "./VideoPlayerControlsBadge.vue?vue&type=script&lang=js"
export * from "./VideoPlayerControlsBadge.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sxdube/Documents/code/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__